import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";

export const getMatchingJudicial = async (filtros = {}, signal = null) => {
    try {
        const { offset, limit, solapa, search, fechaAltaDesde, fechaAltaHasta, fechaDebitoDesde, fechaDebitoHasta, coincidenciaDesde, coincidenciaHasta, jurisdiccion } = filtros;

        const params = new URLSearchParams();

        if (offset !== undefined) params.append('offset', offset);
        if (limit !== undefined) params.append('limit', limit);
        if (solapa) params.append('solapa', solapa);
        if (search?.trim()) params.append('search', search.trim());
        if (fechaAltaDesde) params.append('fechaAltaDesde', fechaAltaDesde);
        if (fechaAltaHasta) params.append('fechaAltaHasta', fechaAltaHasta);
        if (fechaDebitoDesde) params.append('fechaDebitoDesde', fechaDebitoDesde);
        if (fechaDebitoHasta) params.append('fechaDebitoHasta', fechaDebitoHasta);
        if (coincidenciaDesde !== null && coincidenciaDesde !== undefined) params.append('coincidenciaDesde', coincidenciaDesde);
        if (coincidenciaHasta !== null && coincidenciaHasta !== undefined) params.append('coincidenciaHasta', coincidenciaHasta);
        if (jurisdiccion) params.append('jurisdiccion', jurisdiccion);

        const response = await getAuthAxios("default").get(
            `/judicial/matching-judicial?${params}`,
            signal ? { signal } : undefined
        );

        const headers = {
            'x-total-count': response.headers['x-total-count'],
            'x-elements-per-page': response.headers['x-elements-per-page'],
            'x-current-page': response.headers['x-current-page'],
        };

        return {
            registros: response.data.registros || [],
            headers,
        };
    } catch (error) {
        errorService.handleError(error, {
            userMessage: "No pudimos obtener los registros de matching judicial.",
            origen: "getMatchingJudicial",
        });
        throw error;
    }
};
